import React from "react";

const ProductHover = ({ product }) => {
  return (
    <div className="absolute left-0 mt-2 w-64 p-3 bg-white shadow-lg border border-gray-300 rounded-md z-50">
      <h3 className="text-md font-bold text-[#213650]">{product?.product_name || product?.title}</h3>
      <p className="text-sm font-semibold text-[#02336E]">{product?.company_id?.company_name || product?.sub_category_id?.title}</p>
      <p className="text-xs text-gray-700">{product?.description }</p>
    </div>
  );
};

export default ProductHover;
